import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

import {LoginService} from '../login/login.service';
import {UserService} from '../../shared/service/user.service';
import {AlertService} from '../../shared/service/alert.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {

  form: FormGroup;

  submitted: boolean;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private alertService: AlertService
  ) {
  }

  ngOnInit() {
    this.form = this.fb.group({
      oldPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required),
      newPasswordVerify: new FormControl('', Validators.required)
    });
  }

  onSubmit() {
    if (!this.submitted) {
      this.submitted = true;
      this.loginService.changePassword(this.form.value).subscribe(() => {
        this.alertService.onSuccess().then(() => {
          let routerState = UserService.getRouterState();
          if (!routerState) {
            routerState = '/Home/dashboard';
          }
          this.router.navigateByUrl(routerState).then();
        });
      }, () => {
        this.submitted = false;
      });
    }
  }

}
